export default "__VITE_ASSET__DINgJf1i__"